module.exports = __webpack_public_path__ + "img/48.580a6638.jpg";